import styled from '@emotion/styled';
import { Provider } from 'react-redux';

import BreadcrumbsContainer from './BreadcrumbsContainer';
import List from './List';
import Breadcrumbs from '../../Breadcrumbs';
import Modal from '../../Modal';
import Reusable from '../../OC/PageBuilder/Reusable';
import HeroT2 from '../../OC/oc-hero-tier-2';
import Text from '../../OC/oc-text';
import { store } from '../../Store';
import { If, OCNameFilter, PrefixWithLocale } from '../../Utilities';
import { connectLocation } from '../../location/LocationConnectors';
import LocationSwitcher from '../../location/Switcher';
import { stringsFor } from '../../location/locales';
import { FeatureForModal } from '../ShinglesPDP/features';

const FILTER_KEYS = ['colors', 'names', 'prices', 'features', 'windResistances', 'impactResistances', 'warranties'];
const currentLocale = document.querySelector('html').getAttribute('lang');
const colorTranslations = stringsFor(currentLocale).shingles.colors;

export const FeatureModalView = connectLocation(({ feature, locale, onClose, t }) => {
  if (!feature) {
    return null;
  }

  return feature.reusable?.reference ? (
    <Modal open onClose={onClose} name={feature.title}>
      <h3 className="modal-heading">
        <Text content={feature.title} />
      </h3>

      <div className="features-content reusable">
        <Reusable gutterlessChild language={locale?.code} {...feature?.reusable} />
      </div>
    </Modal>
  ) : (
    <Modal open onClose={onClose} name={feature.heading}>
      <FeatureForModal feature={feature} />
    </Modal>
  );
});
FeatureModalView.WrappedComponent.displayName = 'FeatureModalView';

const IndexController = connectLocation(props => {
  const { t, locale } = props;

  return (
    <>
      <BreadcrumbsContainer>
        <Breadcrumbs
          items={[{ text: t('shingles.breadcrumbs.roofing'), href: PrefixWithLocale('/roofing', locale.code) }]}
        />
        <LocationSwitcher showLocale postalRequired />
      </BreadcrumbsContainer>

      <HeroT2
        standalone
        imgDesktop={{
          file:
            'https://imagecdn.owenscorning.com/image/upload/q_60,w_2880/v1759237484/roofing/shingles/pys-hero-2026.jpg',
        }}
        imgTablet={{
          file:
            'https://imagecdn.owenscorning.com/image/upload/q_60/v1759237483/roofing/shingles/pys-hero-2026-tablet.jpg',
        }}
        h1={t('shingles.hero_heading')}
        body={t('shingles.hero_text')}
      />
      <List
        {...props}
      />
    </>
  );
});

const IndexControllerWrapper = props => (
  <Provider store={store}>
    <IndexController {...props} />
  </Provider>
);

export default IndexControllerWrapper;
